import { render, staticRenderFns } from "./SendPreConsultForm.vue?vue&type=template&id=715f4596&lang=pug"
import script from "./SendPreConsultForm.vue?vue&type=script&lang=js"
export * from "./SendPreConsultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SignedSoas: require('/home/docker/code/frontend/components/SignedSoas.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
